import { CompanyAPI } from '@api';

const updateUser = (form) => CompanyAPI.updateUser(form)
  .then(({ data }) => data)
  .catch((error) => Promise.reject(error.response?.data || error.response));

export { updateUser };
